/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { IdleTimeoutProvider } from '../../IdleTimeoutProvider/IdleTimeoutProvider'
import { useTokenRefresher } from '../hooks/useTokenRefresher'
import { FC, PropsWithChildren } from 'react'

export const AuthSessionProvider: FC<PropsWithChildren> = ({ children }) => {
  useTokenRefresher()

  return <IdleTimeoutProvider>{children}</IdleTimeoutProvider>
}
